export default __webpack_public_path__ + "static/media/mark.cddfee4f.svg";